/**
 * @module portal\table\column
 */
import Vue from "vue";
import Component from "vue-class-component";
import TableColumn from "@/components/ghTable/dataTable/tableColumn/tableColumn";
import GhBase from "@/components/ghBase";

@Component({
  components: {
    TableColumn
  }
})
export default class Column extends GhBase {
  protected title = "数据表配置";
  private tableId = "";
  protected onNavigateTo(param) {
    this.tableId = param.tableId;
  }
}
